
import styles from "./ProfileSettingsPage.module.scss";

import { ProfileSettingsForm } from "../../components/ProfileSettings/components/ProfileSettingsForm";
import { ProfileSettingsInfo } from "../../components/ProfileSettings/components/ProfileSettingsInfo";

export const ProfilePage = () => {
  return (
    <div className={styles.root}>
      <ProfileSettingsForm />
      <ProfileSettingsInfo />
    </div>
  );
};
